import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=2aea5b0e&scoped=true"
import script from "./UserNavigation.vue?vue&type=script&lang=js"
export * from "./UserNavigation.vue?vue&type=script&lang=js"
import style0 from "./UserNavigation.vue?vue&type=style&index=0&id=2aea5b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea5b0e",
  null
  
)

export default component.exports